import {
  PROMPT,
  TOUR_OPEN,
  FILTER_OPEN,
  SET_COORDINATES,
  SET_ZOOM,
  SET_INFO,
  SET_CAROUSEL,
} from "../actions/types";

function isPrompt() {
  return window.localStorage.getItem("prompt")
    ? window.localStorage.getItem("prompt") === "true"
      ? false
      : true
    : true;
}

const initialState = {
  tour: false,
  prompt: isPrompt(),
  info: {
    open: false,
    panel: "",
  },
  carousel: "mills",
  filter: false,
  coordinates: {
    langitude: 0,
    longitude: 0,
  },
  zoom: 11,
};

// eslint-disable-next-line
export default function (state = initialState, action) {
  switch (action.type) {
    case SET_CAROUSEL:
      return {
        ...state,
        carousel: action.payload,
      };
    case SET_INFO:
      return {
        ...state,
        info: action.payload,
      };
    case TOUR_OPEN:
      return {
        ...state,
        tour: action.payload,
      };
    case FILTER_OPEN:
      return {
        ...state,
        filter: action.payload,
      };
    case PROMPT:
      return {
        ...state,
        prompt: action.payload,
      };
    case SET_COORDINATES:
      return {
        ...state,
        coordinates: action.payload,
      };
    case SET_ZOOM:
      return {
        ...state,
        zoom: action.payload,
      };
    default:
      return state;
  }
}
